import React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { PersistGate } from "redux-persist/integration/react";
import { Slide, ToastContainer } from "react-toastify";
import { IntercomProvider } from "react-use-intercom";
import SwiperCore, { Navigation } from "swiper/core";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import "react-toastify/dist/ReactToastify.css";
import { Auth, Amplify } from "aws-amplify";
import { Provider } from "react-redux";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";

import Routes from "routes";
import { configureStore } from "redux/store";
import Loading from "components/shared/common/loader";
import { msalConfig } from "components/msal/msalConfig";
import awsconfig from "components/aws-config/awsconfig.js";
import CustomHook from "./CustomHook";
import Layout from "components/layout";

SwiperCore.use([Navigation]);

const { store, persistor } = configureStore();
const INTERCOM_APP_ID = "dii0yx7h";

const App = () => {
  const oauth = {
    domain: process.env.REACT_APP_DOMAIN,
    scope: ["email", "profile", "openid"],
    redirectSignIn:
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_REDIRECTSIGNIN
        : process.env.REACT_APP_REDIRECTSIGNIN,
    redirectSignOut:
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_REDIRECTSIGNOUT
        : process.env.REACT_APP_REDIRECTSIGNOUT,
    responseType: "code"
  };

  Amplify.configure(awsconfig);
  Auth.configure({ oauth: oauth });

  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    <IntercomProvider appId={INTERCOM_APP_ID}>
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <PersistGate loading={null} persistor={persistor}>
            <ToastContainer
              theme="colored"
              hideProgressBar
              autoClose={1200}
              draggable={false}
              transition={Slide}
              closeButton={false}
            />
            <Loading />
            <BrowserRouter>
              <Layout>
                <Routes />
              </Layout>
            </BrowserRouter>
            <CustomHook />
          </PersistGate>
        </MsalProvider>
      </Provider>
    </IntercomProvider>
  );
};

export default App;
